import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { TypeRootState } from '../store/store';

const runtimeBaseUrl =
  // приоритет: глобальная переменная (можно выставить в консоли), затем .env, затем дефолт
  (typeof window !== 'undefined' && (window as any).API_URL) ||
  process.env.REACT_APP_API_URL ||
  ''; // Пустая строка = относительные URL к текущему домену

export const api = createApi({
  reducerPath: 'api',
  tagTypes: [
    'User',
    'Events',
    'UserEvents',
    'UsersInEvent',
    'UsersWhoNotStart',
    'UsersAttempts',
    'Group',
    'UsersInGroup',
    'Problems',
  ],
  baseQuery: fetchBaseQuery({
    baseUrl: `${runtimeBaseUrl}`,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as TypeRootState).auth.token;

      if (token) headers.set('Authorization', `Bearer ${token}`);

      return headers;
    },
  }),
  endpoints: builder => ({}),
});
